'use strict';

var mediator = require('../../js/mediator'),
  ModalView = require('../../js/components/ModalView'),
  productFormModalTemplate = require('../../tmpl/client/modal/productForm.hbs'),
  events = require('../../js/config').events,
  ProductFormModalView;

ProductFormModalView = ModalView.extend({
  template: productFormModalTemplate,

  initialize: function() {
    ProductFormModalView.__super__.initialize.apply(this, arguments);

    mediator.on(events.cart.showProductForm, this.open);
  }
});

module.exports = ProductFormModalView;



// WEBPACK FOOTER //
// ./assets/components/Cart/ProductFormModalView.js